import React, { useState, useEffect } from "react";
import "./frontend_projects.css";
// import Todo from "../assets/todoApp.jpg"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const Frontend_Projects = () => {
  const [swiperInstance, setSwiperInstance] = useState();
  const [disablePrevButton, setDisablePrevButton] = useState(true);
  const [disableNextButton, setDisableNextButton] = useState(false);

  const [manySwipers, setManySwipers] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if(window.innerWidth < 729) {
        setManySwipers(1);
        setDisableNextButton(false);
        setDisablePrevButton(true);
      }
      else if(window.innerWidth < 1011) {
        setManySwipers(2);
        setDisableNextButton(false);
        setDisablePrevButton(true);
      }
      else if(window.innerWidth < 1810) {
        setManySwipers(3);
        setDisableNextButton(false);
        setDisablePrevButton(true);
      }
      else {
        setManySwipers(4);
        setDisableNextButton(true);
        setDisablePrevButton(true);

      };
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  

  const slideChange = (e) => {
    if (e?.isBeginning) {
      setDisablePrevButton(true);
    } else {
      setDisablePrevButton(false);
    }

    if (e?.isEnd) {
      setDisableNextButton(true);
    } else {
      setDisableNextButton(false);
    }
  };

  return (
    <div id="projects" className="frontend_projects">
      <h3 className="projects_title">Projects:</h3>
      <div className="swiper-buttons">
        <button className="swiperButton s-b-1" disabled={disablePrevButton} onClick={() => swiperInstance?.slidePrev()}>
          ← 
        </button>
        <button className="swiperButton s-b-2" disabled={disableNextButton} onClick={() => swiperInstance?.slideNext()}>
          →
        </button>
      </div>
      <div className="projects_wrapper">
     
      <Swiper
      spaceBetween={10}
      slidesPerView={manySwipers}
      onSlideChange={(e) => slideChange(e)}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
    >
     
      <SwiperSlide>
      <div className="project">
          <div className="project1">
            <div className="project_name">
              <span className="buttons">
                <a
                  className="see_button"
                  href="https://moneygem-oe.onrender.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  See Project
                </a>
                <a
                  className="source_button"
                  href="https://github.com/codedit334/budget-app"
                  target="_blank"
                  rel="noreferrer"
                >
                  Source
                </a>
              </span>
            </div>
            <div className="description_1">
              Moneygem (budget-app) is a fullstack web app that allows you to categorize your expenses. It's made using Rails and styled using TailwindCSS.
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className="project">
          <div className="project-2">
            <div className="project_name">
              <span className="buttons">
                <a
                  className="see_button"
                  href="https://concert-react-front-end.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  See Project
                </a>
                <a
                  className="source_button"
                  href="https://github.com/Stephen-Adom/concert-rails-back-end"
                  target="_blank"
                  rel="noreferrer"
                >
                  Source
                </a>
              </span>
            </div>
            <div className="description_1">
              ConcertHub is a Web app that stores and fetches data (Concert) from an API and showcases them in a UI where you can reserve a concert.
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className="project">
          <div className="project-3">
            <div className="project_name">
              <span className="buttons">
                <a
                  className="see_button"
                  href="https://codedit334.github.io/Module1_Capstone-Project/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  See Project
                </a>
                <a
                  className="source_button"
                  href="https://github.com/codedit334/Module1_Capstone-Project"
                  target="_blank"
                  rel="noreferrer"
                >
                  Source
                </a>
              </span>
            </div>
            <div className="description_1">
              All In Campers, is a website that represents AIC, it uses Flexbox
              and css grid for layout. Main Program is rendered using dynamic
              HTML.
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className="project">
          <div className="project-4">
            <div className="project_name">
              <span className="buttons">
                <a
                  className="see_button"
                  href="https://react-bookstore-oe334.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  See Project
                </a>
                <a
                  className="source_button"
                  href="https://github.com/codedit334/Bookstore_ReactJS"
                  target="_blank"
                  rel="noreferrer"
                >
                  Source
                </a>
              </span>
            </div>
            <div className="description_1">
              React _Bookstore is a webapp built using React and Redux, It stores and fetches data from an API.
            </div>
          </div>
        </div>
      </SwiperSlide>
  
    </Swiper>
    
      </div>
    </div>
  );
};

export default Frontend_Projects;
